export abstract class Base64Encoder {

  abstract encodeToString(value: string): string;

  abstract decodeToString(value: string): string;
}
